export interface DashboardCopy {
  title: string;
  locationText: string;
  dataUpdateText: string;
  mapProviderText: string;
  copyrightText: string;
}

export interface MapProviderConfig {
  tdtToken: string;
}

export const dashboardCopy: DashboardCopy = {
  title: '临港道路绿化现状统计看板',
  locationText: '上海浦东新区临港新片区',
  dataUpdateText: '数据更新到 2025/12/5',
  mapProviderText: '天地图',
  copyrightText: '上海勘察设计研究院（集团）股份有限公司 2026',
};

export const mapProviderConfig: MapProviderConfig = {
  tdtToken: '7f98902ef3b7e2145024750dbd648cf6',
};
